import React from 'react';

const Notifications: React.FC = () => {
  return <div></div>;
};
export default Notifications;
